import React, {useCallback, useState} from "react";
import {Row, FormControl, InputGroup} from "react-bootstrap";
import {hashToQueryString, queryStringToHash, updateQueryString} from "./lib/utils";
import {useUpdateEffect} from './lib/customHooks';
import debounce from "lodash/debounce";

const style = Object.freeze({maxWidth: 100});

export const rejectEmptyValue = obj =>
  Object.keys(obj)
    .filter(k => obj[k] !== undefined)
    .reduce((acc, k) => ({...acc, [k]: obj[k]}), {});

const SearchRange = props => {
  const [range, setRange] = useState({[props.minName]: (props.min || ''), [props.maxName]: (props.max || '')});

  const fetch = useCallback(debounce((q) => {
    updateQueryString(rejectEmptyValue(q));
  }, 500), []);

  const handleChange = e => {
    e.persist();
    setRange(old => ({...old, [e.target.name]: e.target.value}));
  };

  useUpdateEffect(() => { fetch(range); }, [range]);

  return (
    <InputGroup className="align-items-center">
      <InputGroup.Text>{props.label}</InputGroup.Text>
      <FormControl
        type="number"
        placeholder="下限"
        style={style}
        name={props.minName}
        defaultValue={range[props.minName] || ''}
        onChange={handleChange} />
      ～
      <FormControl
        type="number"
        placeholder="上限"
        style={style}
        name={props.maxName}
        defaultValue={range[props.maxName] || ''}
        onChange={handleChange} />
    </InputGroup>
  );
}

export default SearchRange;
